import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { ThankYouPage } from './pages/ThankYouPage';
import { BookingPage } from './pages/BookingPage';
import { MetaPixel } from './components/MetaPixel';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-358">
    <BrowserRouter data-id="element-359">
      <MetaPixel data-id="element-360" />
      <Routes data-id="element-361">
        <Route path="/" element={<App data-id="element-363" />} data-id="element-362" />
        <Route path="/privacypolicy" element={<PrivacyPolicy data-id="element-365" />} data-id="element-364" />
        <Route path="/terms" element={<TermsAndConditions data-id="element-367" />} data-id="element-366" />
        <Route path="/thankyoupage" element={<ThankYouPage data-id="element-369" />} data-id="element-368" />
        <Route path="/bookingpage" element={<BookingPage data-id="element-371" />} data-id="element-370" />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>);